// File: src/pages/home/page.tsx
import React from 'react';

import HeroSection from './components/HeroSection';
import EmergencyStrip from './components/EmergencyStrip';
import ServicesSection from './components/ServicesSection';
import ProcessSection from './components/ProcessSection';
import TestimonialsSection from './components/TestimonialsSection';
import SpecialsSection from './components/SpecialsSection';
import ContactSection from './components/ContactSection';
import AreasPreviewSection from './components/AreasPreviewSection';
import Seo from '../../components/feature/Seo';

const Home: React.FC = () => {
  return (
    <main className="min-h-screen bg-white">
      <Seo
        title="Abschleppdienst Berlin 24h | Pannenhilfe & Falschparker | Schiek"
        description="Abschleppdienst Schiek Berlin: 24/7 Pannenhilfe, Unfallbergung, Falschparker auf Privatgrund und Fahrzeugtransport. Direkt anrufen."
        path="/"
      />
      <HeroSection />
      <EmergencyStrip />
      <ServicesSection />
      <AreasPreviewSection />
      <ProcessSection />
      <TestimonialsSection />
      <SpecialsSection />
      <ContactSection />
    </main>
  );
};

export default Home;
